import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import {GamesActionTypes} from "../actions/actionTypes";
import {presetsAPI} from "../../progressivePresets/api/api";

function* getDenominations(action: Action) {
    try {
        const denominations = yield call(() => presetsAPI.getDenominations());

        yield put({
            type: GamesActionTypes.GET_DENOMINATIONS_SUCCESS,
            payload: denominations.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting Denominations.");

        yield put({
            type: GamesActionTypes.GET_DENOMINATIONS_FAIL,
            payload: e
        });
    }
}

export function* getDenominationsWatcher() {
    yield takeLatest(GamesActionTypes.GET_DENOMINATIONS, getDenominations);
}
